import React, { useState } from 'react';
import { Button, Checkbox, Header, Icon, List, Segment } from 'semantic-ui-react';
import { PhoneUtil } from 'utils';
import TierLabel from '../subcomponents/TierLabel';
import { NO_ANSWER_OPTIONS, RECOMMENDATION_TIERS, RING_STRATEGY_OPTIONS, getOptionText } from '../constants';
import { summarizeBusinessHours } from './hoursUtils';

const ConfirmPhoneSetup = ({ values, teamOptions, isApprovedInitially = false, onBack, onConfirm }) => {
    const [isApproved, setIsApproved] = useState(isApprovedInitially);
    const { timezone, business_hours, routing, ivr, voicemail } = values;
    const getTeamName = (team_id) => teamOptions.find(({ value }) => value === team_id)?.text || '';
    const ringingSummary = `${getOptionText(RING_STRATEGY_OPTIONS, routing.ring_strategy)}, for ${getOptionText(PhoneUtil.RING_DURATION_OPTIONS, routing.ring_time)}`;

    return (
        <Segment>
            <Header as='h3'>
                Confirm Your Phone Setup
                <Header.Subheader>Saved as a draft. Routing goes live once your DYL onboarding team has set up your phone number.</Header.Subheader>
            </Header>
            <List divided relaxed>
                <List.Item>
                    <List.Icon name='clock outline' color='blue' />
                    <List.Content>
                        <List.Header>Business Hours</List.Header>
                        <List.Description>{summarizeBusinessHours(business_hours)} ({timezone})</List.Description>
                    </List.Content>
                </List.Item>
                <List.Item>
                    <List.Icon name='sitemap' color='blue' />
                    <List.Content>
                        <List.Header>During Business Hours <TierLabel tier={RECOMMENDATION_TIERS.REQUIRES_ACTIVATION} size='mini' /></List.Header>
                        <List.Description>
                            {ivr.enabled ? (
                                <>
                                    Callers hear a menu:{' '}
                                    {ivr.options.map(({ digit, team_id }) => `${digit} → ${getTeamName(team_id)}`).join(', ')}.
                                </>
                            ) : `Calls ring ${getTeamName(routing.team_id)}.`}
                            {' '}Team phones ring: {ringingSummary}. If nobody answers: {getOptionText(NO_ANSWER_OPTIONS, routing.no_answer_destination).toLowerCase()}.
                        </List.Description>
                    </List.Content>
                </List.Item>
                {ivr.enabled && (
                    <List.Item>
                        <List.Icon name='bullhorn' color='blue' />
                        <List.Content>
                            <List.Header>Menu Greeting Script</List.Header>
                            <List.Description><i>"{ivr.greeting_script}"</i></List.Description>
                        </List.Content>
                    </List.Item>
                )}
                <List.Item>
                    <List.Icon name='microphone' color='blue' />
                    <List.Content>
                        <List.Header>After Hours: Company Voicemail</List.Header>
                        <List.Description><i>"{voicemail.greeting_script}"</i></List.Description>
                    </List.Content>
                </List.Item>
            </List>
            <Segment secondary>
                <Checkbox
                    checked={isApproved}
                    onChange={(_, { checked }) => setIsApproved(checked)}
                    label="I've reviewed this phone setup and approve it as my configuration draft"
                />
            </Segment>
            <Button basic type='button' onClick={onBack}><Icon name='arrow left' /> Back</Button>
            <Button primary floated='right' type='button' disabled={!isApproved} onClick={onConfirm}>
                Continue to CRM Configuration <Icon name='arrow right' />
            </Button>
            <div style={{ clear: 'both' }} />
        </Segment>
    );
}

export default ConfirmPhoneSetup;
